import PropTypes from 'prop-types';

const SalarySvg = ({ width, height, mixBlendMode, palette = [] }) => {
  return (
    <svg
      width={`${width || 51}`}
      height={`${height || 50}`}
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        style={{ mixBlendMode: mixBlendMode || 'normal' }}
        clipPath={`url(#clip0_665_6880${width + height})`}
      >
        <path
          d="M49.3682 23.6328H2.29785C1.48818 23.6328 0.833008 24.288 0.833008 25.0977V48.5352C0.833008 49.3448 1.48818 50 2.29785 50H49.3682C50.1778 50 50.833 49.3448 50.833 48.5352V25.0977C50.833 24.288 50.1778 23.6328 49.3682 23.6328Z"
          fill={`url(#paint0_linear_665_6880${width + height})`}
        />
        <path
          d="M19.6218 30.9571C19.6218 30.1474 18.9666 29.4922 18.1569 29.4922H11.1846C10.3749 29.4922 9.71973 30.1474 9.71973 30.9571C9.71973 31.7653 9.06309 32.4219 8.25488 32.4219C7.44521 32.4219 6.79004 33.0771 6.79004 33.8867V39.7461C6.79004 40.5558 7.44521 41.211 8.25488 41.211C9.06309 41.211 9.71973 41.8676 9.71973 42.6758C9.71973 43.4855 10.3749 44.1406 11.1846 44.1406H18.1568C18.9665 44.1406 19.6217 43.4855 19.6217 42.6758C19.6217 41.8661 18.9665 41.211 18.1568 41.211H12.399C11.957 39.9636 10.9671 38.9737 9.71963 38.5316V35.1012C10.967 34.6592 11.9569 33.6693 12.399 32.4218H18.1568C18.9666 32.4219 19.6218 31.7667 19.6218 30.9571ZM43.4111 32.4219C42.6029 32.4219 41.9463 31.7653 41.9463 30.9571C41.9463 30.1474 41.2911 29.4922 40.4814 29.4922H33.5092C32.6995 29.4922 32.0443 30.1474 32.0443 30.9571C32.0443 31.7667 32.6995 32.4219 33.5092 32.4219H39.267C39.709 33.6693 40.6989 34.6592 41.9464 35.1013V38.5317C40.699 38.9737 39.7091 39.9636 39.267 41.2111H33.5092C32.6995 41.2111 32.0443 41.8662 32.0443 42.6759C32.0443 43.4856 32.6995 44.1407 33.5092 44.1407H40.4814C41.2911 44.1407 41.9463 43.4856 41.9463 42.6759C41.9463 41.8677 42.6029 41.2111 43.4111 41.2111C44.2208 41.2111 44.876 40.5559 44.876 39.7462V33.8868C44.876 33.0771 44.2208 32.4219 43.4111 32.4219ZM25.833 29.4922C23.3282 29.4922 21.4385 32.6407 21.4385 36.8164C21.4385 40.9921 23.3282 44.1406 25.833 44.1406C28.3378 44.1406 30.2275 40.9921 30.2275 36.8164C30.2275 32.6407 28.3378 29.4922 25.833 29.4922ZM17.0439 35.3516H14.1143C13.3046 35.3516 12.6494 36.0068 12.6494 36.8164C12.6494 37.6261 13.3046 38.2813 14.1143 38.2813H17.0439C17.8536 38.2813 18.5088 37.6261 18.5088 36.8164C18.5088 36.0068 17.8536 35.3516 17.0439 35.3516ZM34.6221 38.2813H37.5518C38.3614 38.2813 39.0166 37.6261 39.0166 36.8164C39.0166 36.0068 38.3614 35.3516 37.5518 35.3516H34.6221C33.8124 35.3516 33.1572 36.0068 33.1572 36.8164C33.1572 37.6261 33.8124 38.2813 34.6221 38.2813ZM32.9229 9.40422L27.0635 0.615161C26.5068 -0.205054 25.1593 -0.205054 24.6026 0.615161L18.7433 9.40422C18.1029 10.4285 18.8275 11.6895 19.9736 11.6895H22.9033V19.0137C22.9033 19.8339 23.5478 20.4785 24.3682 20.4785H27.2979C28.1183 20.4785 28.7627 19.8339 28.7627 19.0137V11.6895H31.6924C32.8376 11.6895 33.5632 10.4287 32.9229 9.40422Z"
          fill={`url(#paint1_linear_665_6880${width + height})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_665_6880${width + height}`}
          x1="25.833"
          y1="50"
          x2="25.833"
          y2="23.6328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_665_6880${width + height}`}
          x1="25.833"
          y1="44.1407"
          x2="25.833"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <clipPath id={`clip0_665_6880${width + height}`}>
          <rect
            width="50"
            height="50"
            fill="white"
            transform="translate(0.833008)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

SalarySvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  mixBlendMode: PropTypes.string,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default SalarySvg;
